export default __webpack_public_path__ + "static/media/0777ROUGE.0848e511.pdf";